export default __webpack_public_path__ + "static/media/icon-30.b691dfa7.png";